import React from 'react';
import { Modal, ScrollView, VStack, Link } from 'native-base';
import { Caption, H3 } from '~/shared/Typography';
import { useModalStyles } from '~/shared/styles';
import { useI18n, Reward } from '@springbig/shared';
import { AppStore, GooglePlay } from '../assets';

type Links = {
  app_store_url?: string;
  google_play_url?: string;
}

export type DesiredActionType = {
  id: number;
  name: string;
  rewards: Reward[];
  reward_names?: string[];
  type_id: number;
  links: Links;
};

type AppDownloadType = {
  isOpen: boolean;
  closeModal: () => void;
  action: DesiredActionType;
  merchantName: string;
};

const AppDownloadModal = (props: AppDownloadType) => {
    const rewards = (props.action.reward_names ?? []).join(', ');

    const {
        text,
        header_background,
    } = useModalStyles();

    const app_store_url = props.action.links.app_store_url ?? '';
    const google_play_url = props.action.links.google_play_url ?? '';

    const { t } = useI18n();

    return (
        <Modal isOpen={props.isOpen}>
            <Modal.Content>
                <Modal.Header>
                    <H3
                        color={text}
                        textTransform={'capitalize'}
                    >
            download the {props.merchantName} app!
                    </H3>
                </Modal.Header>
                <Modal.CloseButton
                    bg={header_background}
                    onPress={props.closeModal}
                />
                <Modal.Body>
                    <ScrollView>
                        <VStack justifyContent='center' alignItems='center' space={4}>
                            <Caption
                                color={text}
                                textAlign='center'
                            >
                                {t('offers.app_download_desirable_action_get_text', [props.merchantName])}
                                {!!rewards.length && t('offers.app_download_desirable_action_rewards')}
                                {!!rewards.length && <Caption fontWeight="bold">{` ${rewards}`}</Caption>}
                            </Caption>
                            {!!app_store_url.length && <Link href={app_store_url}><img alt='App Store' width={170} src={AppStore}/></Link>}
                            {!!google_play_url.length && <Link href={google_play_url}><img alt='Google Play Market' width={170} src={GooglePlay}/></Link>}
                        </VStack>
                    </ScrollView>
                </Modal.Body>
                <Modal.Footer>

                </Modal.Footer>
            </Modal.Content>
        </Modal>
    );
};

export default AppDownloadModal;
